"use client";

import { createClient } from "@/shared";
import { faDownload } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface PostFileDownLoadProps {
  files: any[];
}
export default function PostFileDownLoad({ files }: PostFileDownLoadProps) {
  if (!files || files.length === 0) return null;

  const fileSize = (size: number) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
    if (size < 1024 * 1024 * 1024)
      return `${(size / 1024 / 1024).toFixed(2)} MB`;
    return `${(size / 1024 / 1024 / 1024).toFixed(2)} GB`;
  };

  const onDownloadFile = async (file: any) => {
    const supabase = await createClient();
    const { data, error } = await supabase.storage
      .from("wezon")
      .download(file.file_url);
    if (error) {
      console.error(error);
      return;
    }

    const blob = new Blob([await data.arrayBuffer()]);

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.setAttribute("href", url);
    link.setAttribute("download", file.name);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  return (
    <ul className="md:py-10 py-5 md:space-y-3 space-y-2">
      {files.map((file, index) => (
        <li key={index}>
          <button
            className="flex justify-between w-full items-center bg-light-20 md:px-8 md:py-6 px-5 py-5 rounded-2xl"
            onClick={() => onDownloadFile(file)}
          >
            <div className="flex flex-col grow space-y-1 text-left">
              <p
                className="tracking-tight md:text-base text-sm text-midGray-30 md:leading-6 leading-4 "
                style={{ fontFamily: '"pre-Medium", sans-serif' }}
              >
                {file.name}
              </p>

              <p
                className="tracking-tight md:text-sm text-xs text-softGray-60 md:leading-4 leading-3.5 "
                style={{ fontFamily: '"pre-Medium", sans-serif' }}
              >
                {fileSize(file.size)}
              </p>
            </div>

            <FontAwesomeIcon
              icon={faDownload}
              className="md:text-xl text-lg text-softGray-50"
            />
          </button>
        </li>
      ))}
    </ul>
  );
}
